var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-layout"},[_c('div',{ref:"page",class:['page-content', _vm.layout, _vm.pageWidth]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }